var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_43910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2326 25.9119V12.9725H6.84683V25.9119H11.2326ZM9.04028 11.2048C10.5697 11.2048 11.5216 10.2112 11.5216 8.96956C11.4931 7.6999 10.5697 6.73389 9.0693 6.73389C7.56911 6.73389 6.58807 7.69992 6.58807 8.96956C6.58807 10.2113 7.53981 11.2048 9.01165 11.2048H9.04014H9.04028ZM13.6601 25.9119H18.0459V18.6859C18.0459 18.2992 18.0744 17.9129 18.1902 17.6364C18.5072 16.8638 19.2289 16.0635 20.4404 16.0635C22.0274 16.0635 22.6623 17.2501 22.6623 18.9895V25.9118H27.0478V18.4925C27.0478 14.518 24.8841 12.6688 21.9985 12.6688C19.6326 12.6688 18.5938 13.9656 18.0167 14.8489H18.046V12.9723H13.6602C13.7178 14.1864 13.6602 25.9117 13.6602 25.9117L13.6601 25.9119Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_43910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4566,
    height: 19.178,
    fill: "white",
    transform: "translate(6.58701 6.73389)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.08a0d3a413c8bda9ee85670e6849d600.svg";
export { ForwardRef as ReactComponent };